// MobileMenu.jsx
"use client";

import React, { useState } from "react";
import Link from "next/link";
import CommonButton from "../CommonButton/CommonButton";
import { blockchainMainItemMobile } from "../Header/HeaderData/Mobile/blockchainData";
import MobileDropdownMainItm from "../Header/HeaderData/Mobile/MobileDropdownMainItm";
import MobileDropdownSubItm from "../Header/HeaderData/Mobile/MobileDropdownSubItm";
import { gamesMainItemMobile } from "../Header/HeaderData/Mobile/gamesData";
import { industriesMainItemMobile } from "../Header/HeaderData/Mobile/industriesData";
import { aboutMainItemMobile } from "../Header/HeaderData/Mobile/aboutData";
import { IoClose } from "react-icons/io5";
import { BiChevronDown } from "react-icons/bi";

const MobileMenu = ({ navTextColor, scrollPosition }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(-1); // Tracks main accordion
  const [subShow, setSubShow] = useState(-1); // Tracks sub-item dropdown
  const [service, setService] = useState(-1); // Tracks which main item is active

  const openNav = () => {
    setIsSidebarOpen(true);
  };

  const closeNav = () => {
    setIsSidebarOpen(false);
    setService(-1);
    setSubShow(-1);
    setIsOpen(-1);
  };

  const subDropdown = (mainId, id) => {
    if (subShow === id && service === mainId) {
      setSubShow(-1);
      setService(-1);
    } else {
      setSubShow(id);
      setService(mainId);
    }
  };

  const openAccordion = (id) => {
    setIsOpen(isOpen === id ? -1 : id);
    // Reset sub-items when closing accordion
    if (isOpen === id) {
      setSubShow(-1);
      setService(-1);
    }
  };

  return (
    <div className="mobileView fixed top-0 left-0 w-full z-[1000] md:hidden block">
      {/* Top Bar with Logo, Button, and Hamburger Icon */}
      <div className="flex justify-between items-center xl:mx-10 lg:mx-10 px-3 py-3 bg-white shadow-sm">
        <Link href="/" className="flex items-center">
          <img src="/MainLogo-dark.svg" alt="Tanthetaa-logo" className="w-24 cursor-pointer" />
        </Link>
        <div className="flex gap-2 items-center">
          <CommonButton href="/contact" name="Contact Us" className={"common-blue-button-style"} />
          <button onClick={openNav} className="p-2 focus:outline-none">
            <img className="w-8" src="/assets/MobileBtn.webp" alt="Hamburger Icon" />
          </button>
        </div>
      </div>

      {/* Backdrop */}
      <div
        className={`fixed inset-0 bg-black transition-opacity duration-300 ${isSidebarOpen ? "opacity-50" : "opacity-0 pointer-events-none"
          }`}
        onClick={closeNav}
      />

      {/* Sidebar (Right-to-Left) */}
      <div
        className={`fixed top-0 right-0 h-full w-72 bg-white shadow-lg transform transition-transform duration-300 ease-in-out ${isSidebarOpen ? "translate-x-0" : "translate-x-full"
          }`}
      >
        <div className="flex justify-end p-4">
          <button onClick={closeNav} className="text-xl text-gray-600 hover:text-gray-800 focus:outline-none">
            <IoClose />
          </button>
        </div>

        <div className="flex flex-col h-full overflow-y-auto pb-10">
          {/* Services */}
          <div className="flex items-center pr-2">
            <button
              className="dropdown-btn px-3 py-2 text-left w-full font-manrope font-medium text-gray-800 hover:bg-gray-100 transition-colors"
              onClick={() => openAccordion(1)}
            >
              Services
            </button>
            <div className={`accordion-bg p-2 ${isOpen === 1 ? "open" : "close"}`} onClick={() => openAccordion(1)}>
              {/* <img
                  src="/assets/menuarrow.webp"
                  alt="menuarrow"
                  className={`faq-arrow !w-10 transform transition-transform duration-200 ${
                    isOpen === 1 ? "rotate-90" : "rotate-0"
                  }`}
                /> */}
              <BiChevronDown
                style={{ color: "black" }}
                className={`w-5 h-5 transform transition-transform duration-200 ${isOpen === 1 ? "rotate-90" : "rotate-0"
                  }`}
              />
            </div>
          </div>
          {isOpen === 1 && (
            <div className="px-3 bg-gray-50">
              {blockchainMainItemMobile?.map((e, ind) => (
                <div key={e.id || ind}>
                  <MobileDropdownMainItm
                    e={e}
                    mainId={1}
                    subDropdown={subDropdown}
                    isSubOpen={subShow === e.id && service === 1}
                  />
                  {subShow === 1 && service === 1 && (
                    <>
                      {e.nfts?.map((e, ind) => (
                        <div key={e.id || ind}>
                          <MobileDropdownSubItm e={e} closeNav={closeNav} />
                        </div>
                      ))}
                    </>
                  )}
                  {subShow === 2 && service === 1 && (
                    <>
                      {e.evm?.map((e, ind) => (
                        <div key={e.id || ind}>
                          <MobileDropdownSubItm e={e} closeNav={closeNav} />
                        </div>
                      ))}
                    </>
                  )}
                  {subShow === 3 && service === 1 && (
                    <>
                      {e.blockchain?.map((e, ind) => (
                        <div key={e.id || ind}>
                          <MobileDropdownSubItm e={e} closeNav={closeNav} />
                        </div>
                      ))}
                    </>
                  )}
                  {subShow === 4 && service === 1 && (
                    <>
                      {e.metaverse?.map((e, ind) => (
                        <div key={e.id || ind}>
                          <MobileDropdownSubItm e={e} closeNav={closeNav} />
                        </div>
                      ))}
                    </>
                  )}
                  {subShow === 5 && service === 1 && (
                    <>
                      {e.web3?.map((e, ind) => (
                        <div key={e.id || ind}>
                          <MobileDropdownSubItm e={e} closeNav={closeNav} />
                        </div>
                      ))}
                    </>
                  )}
                  {subShow === 6 && service === 1 && (
                    <>
                      {e.crypto?.map((e, ind) => (
                        <div key={e.id || ind}>
                          <MobileDropdownSubItm e={e} closeNav={closeNav} />
                        </div>
                      ))}
                    </>
                  )}
                  {subShow === 7 && service === 1 && (
                    <>
                      {e.defi?.map((e, ind) => (
                        <div key={e.id || ind}>
                          <MobileDropdownSubItm e={e} closeNav={closeNav} />
                        </div>
                      ))}
                    </>
                  )}
                  {subShow === 8 && service === 1 && (
                    <>
                      {e.GenerativeAI?.map((e, ind) => (
                        <div key={e.id || ind}>
                          <MobileDropdownSubItm e={e} closeNav={closeNav} />
                        </div>
                      ))}
                    </>
                  )}
                  {subShow === 9 && service === 1 && (
                    <>
                      {e.icoStoIdo?.map((e, ind) => (
                        <div key={e.id || ind}>
                          <MobileDropdownSubItm e={e} closeNav={closeNav} />
                        </div>
                      ))}
                    </>
                  )}
                  {subShow === 10 && service === 1 && (
                    <>
                      {e.marketing?.map((e, ind) => (
                        <div key={e.id || ind}>
                          <MobileDropdownSubItm e={e} closeNav={closeNav} />
                        </div>
                      ))}
                    </>
                  )}
                </div>
              ))}
            </div>
          )}

          {/* Games */}
          <div className="flex items-center pr-2">
            <button
              className="dropdown-btn px-3 py-2 text-left w-full font-manrope font-medium text-gray-800 hover:bg-gray-100 transition-colors"
              onClick={() => openAccordion(2)}
            >
              Games
            </button>
            <div className={`accordion-bg p-2 ${isOpen === 2 ? "open" : "close"}`} onClick={() => openAccordion(2)}>
              {/* <img
                  src="/assets/menuarrow.svg"
                  alt="menuarrow"
                  className={`faq-arrow !w-10 transform transition-transform duration-200 ${
                    isOpen === 2 ? "rotate-90" : "rotate-0"
                  }`}
                /> */}
              <BiChevronDown
                style={{ color: "black" }}
                className={`w-5 h-5 transform transition-transform duration-200 ${isOpen === 2 ? "rotate-90" : "rotate-0"
                  }`}
              />
            </div>
          </div>
          {isOpen === 2 && (
            <div className="px-3 bg-gray-50">
              {gamesMainItemMobile?.map((e, ind) => (
                <div key={e.id || ind}>
                  <MobileDropdownMainItm
                    e={e}
                    mainId={2}
                    subDropdown={subDropdown}
                    isSubOpen={subShow === e.id && service === 2}
                  />
                  {subShow === 1 && service === 2 && (
                    <>
                      {e.gameDevelopment?.map((e, ind) => (
                        <div key={e.id || ind}>
                          <MobileDropdownSubItm e={e} closeNav={closeNav} />
                        </div>
                      ))}
                    </>
                  )}
                  {subShow === 2 && service === 2 && (
                    <>
                      {e.gameArt?.map((e, ind) => (
                        <div key={e.id || ind}>
                          <MobileDropdownSubItm e={e} closeNav={closeNav} />
                        </div>
                      ))}
                    </>
                  )}
                  {subShow === 3 && service === 2 && (
                    <>
                      {e.animation?.map((e, ind) => (
                        <div key={e.id}>
                          <MobileDropdownSubItm e={e} closeNav={closeNav} />
                        </div>
                      ))}
                    </>
                  )}
                </div>
              ))}
            </div>
          )}

          {/* Industries */}
          <div className="flex items-center pr-2">
            <button
              className="dropdown-btn px-3 py-2 text-left w-full font-manrope font-medium text-gray-800 hover:bg-gray-100 transition-colors"
              onClick={() => openAccordion(3)}
            >
              Industries
            </button>
            <div className={`accordion-bg p-2 ${isOpen === 3 ? "open" : "close"}`} onClick={() => openAccordion(3)}>
              {/* <img
                  src="/assets/menuarrow.svg"
                  alt="menuarrow"
                  className={`faq-arrow !w-10 transform transition-transform duration-200 ${
                    isOpen === 3 ? "rotate-90" : "rotate-0"
                  }`}
                /> */}
              <BiChevronDown
                style={{ color: "black" }}
                className={`w-5 h-5 transform transition-transform duration-200 ${isOpen === 3 ? "rotate-90" : "rotate-0"
                  }`}
              />
            </div>
          </div>
          {isOpen === 3 && (
            <div className="px-3 bg-gray-50">
              {industriesMainItemMobile?.map((e, ind) => (
                <div key={e.id || ind}>
                  <MobileDropdownMainItm
                    e={e}
                    mainId={3}
                    subDropdown={subDropdown}
                    isSubOpen={subShow === e.id && service === 3}
                  />
                  {subShow === 1 && service === 3 && (
                    <>
                      {e.onDemand?.map((e,ind) => (
                        <div key={e.id||ind}>
                          <MobileDropdownSubItm e={e} closeNav={closeNav} />
                        </div>
                      ))}
                    </>
                  )}
                  {subShow === 2 && service === 3 && (
                    <>
                      {e.foodRestaurant?.map((e, ind) => (
                        <div key={e.id || ind}>
                          <MobileDropdownSubItm e={e} closeNav={closeNav} />
                        </div>
                      ))}
                    </>
                  )}
                  {subShow === 3 && service === 3 && (
                    <>
                      {e.bankingFinance?.map((e, ind) => (
                        <div key={e.id || ind}>
                          <MobileDropdownSubItm e={e} closeNav={closeNav} />
                        </div>
                      ))}
                    </>
                  )}
                  {subShow === 4 && service === 3 && (
                    <>
                      {e.ecommerce?.map((e, ind) => (
                        <div key={e.id || ind}>
                          <MobileDropdownSubItm e={e} closeNav={closeNav} />
                        </div>
                      ))}
                    </>
                  )}
                  {subShow === 5 && service === 3 && (
                    <>
                      {e.healthcareFitness?.map((e, ind) => (
                        <div key={e.id || ind}>
                          <MobileDropdownSubItm e={e} closeNav={closeNav} />
                        </div>
                      ))}
                    </>
                  )}
                  {subShow === 6 && service === 3 && (
                    <>
                      {e.education?.map((e, ind) => (
                        <div key={e.id || ind}>
                          <MobileDropdownSubItm e={e} closeNav={closeNav} />
                        </div>
                      ))}
                    </>
                  )}
                </div>
              ))}
            </div>
          )}

          {/* Case Studies */}
          <div className="flex pr-2">
            <Link
              href="/portfolio"
              className="dropdown-btn px-3 py-2 font-manrope font-medium text-gray-800 hover:bg-gray-100 transition-colors w-full text-left"
              onClick={closeNav}
            >
              Case Studies
            </Link>
          </div>

          {/* Blog */}
          <div className="flex pr-2">
            <Link
              href="/blog"
              className="dropdown-btn px-3 py-2 font-manrope font-medium text-gray-800 hover:bg-gray-100 transition-colors w-full text-left"
              onClick={closeNav}
            >
              Blogs
            </Link>
          </div>

          {/* About Us */}
          <div className="flex items-center pr-2">
            <button
              className="dropdown-btn px-3 py-2 text-left w-full font-manrope font-medium text-gray-800 hover:bg-gray-100 transition-colors"
              onClick={() => openAccordion(4)}
            >
              About Us
            </button>
            <div className={`accordion-bg p-2 ${isOpen === 4 ? "open" : "close"}`} onClick={() => openAccordion(4)}>
              {/* <img
                  src="/assets/menuarrow.svg"
                  alt="menuarrow"
                  className={`faq-arrow !w-10 transform transition-transform duration-200 ${
                    isOpen === 4 ? "rotate-90" : "rotate-0"
                  }`}
                /> */}
              <BiChevronDown
                style={{ color: "black" }}
                className={`w-5 h-5 transform transition-transform duration-200 ${isOpen === 4 ? "rotate-90" : "rotate-0"
                  }`}
              />
            </div>
          </div>
          {isOpen === 4 && (
            <div className="px-3 bg-gray-50">
              {aboutMainItemMobile?.map((e, ind) => (
                <div key={e.id || ind}>
                  <MobileDropdownMainItm
                    e={e}
                    mainId={4}
                    subDropdown={subDropdown}
                    isSubOpen={subShow === e.id && service === 4}
                  />
                  {subShow === 1 && service === 4 && (
                    <>
                      {e.companyData?.map((e, ind) => (
                        <div key={e.id || ind}>
                          <MobileDropdownSubItm e={e} closeNav={closeNav} />
                        </div>
                      ))}
                    </>
                  )}
                  {subShow === 2 && service === 4 && (
                    <>
                      {e.projectCosting?.map((e, ind) => (
                        <div key={e.id || ind}>
                          <MobileDropdownSubItm e={e} closeNav={closeNav} />
                        </div>
                      ))}
                    </>
                  )}
                  {subShow === 3 && service === 4 && (
                    <>
                      {e.dedicatedResources?.map((e, ind) => (
                        <div key={e.id || ind}>
                          <MobileDropdownSubItm e={e} closeNav={closeNav} />
                        </div>
                      ))}
                    </>
                  )}
                </div>
              ))}
            </div>
          )}

          <div onClick={closeNav} className="w-full my-6 flex justify-center items-center">
            <div className="w-fit">
              <CommonButton href={`/contact`} name={`Contact Us`} className={"common-blue-button-style"} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileMenu;
